var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 2,
    y1: 32,
    x2: 62.133,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4761ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54c2ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 2,
    y1: 42.5,
    x2: 62.133,
    y2: 42.5,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-3",
    x1: 2,
    y1: 38.5,
    x2: 62.133,
    y2: 38.5,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-4",
    x1: 2,
    y1: 28,
    x2: 62.133,
    y2: 28,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-5",
    x1: 2,
    y1: 17,
    x2: 62.133,
    y2: 17,
    xlinkHref: "#New_Gradient_Swatch_5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gradient_outline",
    "data-name": "Gradient outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,27H59.841C57.386,13.505,44.18,2.607,29.412,2.025,29.279,2.012,29.133,2,29,2a4,4,0,1,0,3.955,4.442C38.712,10.752,42.09,17.878,42.09,26c0,.339-.011.676-.027,1H41a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h1.689A24.108,24.108,0,0,1,38.5,41H29a1,1,0,0,0-.895,1.447l2.559,5.116A24.713,24.713,0,0,1,20,50,22.674,22.674,0,0,1,3.7,43.284a1,1,0,0,0-1.61,1.127A29.293,29.293,0,0,0,29,62,30.031,30.031,0,0,0,58.975,33H61a1,1,0,0,0,1-1V28A1,1,0,0,0,61,27ZM29,8a2,2,0,1,1,2-2A2,2,0,0,1,29,8Zm24.66,9.339a26.887,26.887,0,0,1,2.824,5.249A2.946,2.946,0,0,1,55,23a2.986,2.986,0,0,1-1.34-5.661ZM33.753,4.532a31.768,31.768,0,0,1,18.7,11.2,4.97,4.97,0,0,0,4.7,8.753A23.975,23.975,0,0,1,57.813,27H44.065c.015-.322.025-.659.025-1a30.353,30.353,0,0,0-.319-4.343A4.989,4.989,0,0,0,42,12a4.789,4.789,0,0,0-1.391.216A23.715,23.715,0,0,0,33.753,4.532Zm7.791,9.526A2.845,2.845,0,0,1,42,14a3,3,0,0,1,3,3,2.967,2.967,0,0,1-1.589,2.631A26.983,26.983,0,0,0,41.544,14.058ZM29,60A27.134,27.134,0,0,1,6.384,48.011,24.347,24.347,0,0,0,20,52a26.852,26.852,0,0,0,7.345-1.052,7.594,7.594,0,0,0,7.069,3.889,15.558,15.558,0,0,0,4.9-.888l-.632-1.9c-6.206,2.067-8.624-.46-9.41-1.731a24.949,24.949,0,0,0,3.2-1.441,1,1,0,0,0,.418-1.326L30.618,43h8.364a1,1,0,0,0,.774-.366A26.123,26.123,0,0,0,44.771,33H56.982A28.034,28.034,0,0,1,29,60ZM60,31H42V29H60Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,45a5.006,5.006,0,0,0,5-5H52a3,3,0,0,1-6,0H44A5.006,5.006,0,0,0,49,45Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.076,41.383A1,1,0,0,0,15,42h5a1,1,0,0,0,0-2H17.414l3.293-3.293A1,1,0,0,0,20,35H15a1,1,0,0,0,0,2h2.586l-3.293,3.293A1,1,0,0,0,14.076,41.383Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.924,24.617A1,1,0,0,0,33,24H27a1,1,0,0,0,0,2h3.586l-4.293,4.293A1,1,0,0,0,27,32h6a1,1,0,0,0,0-2H29.414l4.293-4.293A1,1,0,0,0,33.924,24.617Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14h5.586l-6.293,6.293A1,1,0,0,0,14,22h8a1,1,0,0,0,0-2H16.414l6.293-6.293A1,1,0,0,0,22,12H14a1,1,0,0,0,0,2Z",
    style: {
      fill: "url(#New_Gradient_Swatch_5-5)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.bdf5aca7.svg";
export { ForwardRef as ReactComponent };